//报告说明
export const reportInfo = {
    content1: "本次人才盘点项目由素质测评、履职绩效评价、360°胜任力评价、现场行为访谈四部分构成。各环节成果互相印证并补充，最终形成评分结果和综合评价。",
    content2: "素质测评（线上）以“大五人格特质”为理论基础，用于评估评价对象在工作场景下的个性特征、行为倾向和胜任力潜质。",
    content3: "360°胜任力评价（线上）旨在以评价对象上级、有密切工作关系的平级和下属员工的评价为依据，全方位评估评价对象在履职表现与干事能力方面的受认可度。",
    content4:"现场访谈（线下）的考察指标与线上评价指标具有对应关系，即中智专家基于线上评价结果（个人工作表现和能力状态），运用“STAR”等行为访谈技术，对被访者经历的一系列关键事件进行反复提问，通过深入回顾被访者在过去有代表性事件中的真实思想和行为，进一步评估盘点对象的各项能力素质。该项结果将呈现在本报告中的“综合评价”部分。",
    info:"本次盘点过程中涉及到的数据和结论不作为评定盘点对象的唯一依据。结果只做盘点用不与考核和其他事项挂钩。本报告内容属于组织与个人隐私，请注意保密。如果报告有任何疑问，可致电86-10-65613920 转8612，联系人：吴先生。",
}



// WEBPACK FOOTER //
// ./src/views/CNBM/data/content-text.js